import { render } from "./ColorScheme.vue?vue&type=template&id=7a0de8f1&lang=pug"
import script from "./ColorScheme.vue?vue&type=script&lang=js"
export * from "./ColorScheme.vue?vue&type=script&lang=js"

import "./ColorScheme.vue?vue&type=style&index=0&id=7a0de8f1&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__